export default 'intl' as const;
